import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';

registerLocaleData(localeIT);

@Pipe({
  name: 's1ItalianNumber'
})
export class S1ItalianNumberPipe extends DecimalPipe implements PipeTransform {

  transform(value: number): any
  transform(value: number): string {

    return super.transform(value, '1.0-2', 'it')

  }

}
